module.exports = __webpack_public_path__ + "assets/img/21_799_big.6bf57a8c.jpg";